import { createFileRoute } from "@tanstack/react-router";

import { CoachAthleteQuestionnaireSubmissionsPage } from "src/pages/CoachAthleteQuestionnaireSubmissionsPage";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/",
)({ component: CoachAthleteQuestionnaireSubmissionsPage });
